import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import Chart from "chart.js";
import { GoogleAnalyticsService } from "ngx-google-analytics";
import { timer } from "rxjs";
import { take } from "rxjs/operators";
import { applyRegion, environment } from "src/environments/environment";
import * as _ from "underscore";
import { find } from "underscore";
import { ResponseJobInfo } from "../commons/interfaces";
import { print_duration } from "../commons/utils";
import { ResponseJobResultTopicsV2 } from "../news-analyzer/interfaces";
import {
    NodeItem, EdgeItem, cleanSuspectNodes, getPartners, addEdge,
    removeNonConnectedNodes, mergeSimilarNodes, mergeSimilarEdges, cleanEdgesBasedOnAmount
} from "../news-analyzer/news-analyzer.utils";
import { getColor, rgba2rgb } from "../news-analyzer/utils";


@Component({
    selector: "app-topics-analyzer",
    templateUrl: "./topics-analyzer.component.html",
    styleUrls: ["./topics-analyzer.component.css"]
})
export class TopicsAnalyzerComponent implements OnInit {
    BATCH_SIZE = 100;

    providerInfoForm: FormGroup;
    nerTypes = []
    summary: string;
    selectedNERType: string;
    commentsNer: {};
    commentsNerLabels: string[];
    chartOptions: {};
    barChartNer: Chart;
    barChartTopics: Chart;
    barChartSentiment: Chart;
    showResults: boolean;
    progressInfo: {
        total: number,
        current: number,
        position: number | null,
        description: string
    };
    article = {
        text: '',
        comments: [],
        paragraphs: []
    };
    isProcessingArticle: boolean;
    itemsTitle = '';
    itemsLength = 0;
    tokenHasError: any[];
    hasErrorProcessing: any[];
    pairsKeyLongKey = [
        ['ADR', 'Dirección'],
        ['ANM', 'Animal'],
        ['BLD', 'Construcción'],
        ['COM', 'Compañía'],
        ['DAT', 'Fecha'],
        ['DEV', 'Dispositivo'],
        ['DOC', 'Documento'],
        ['EVN', 'Evento'],
        ['FDD', 'Comida'],
        ['GEA', 'Geografía física'],
        ['GEO', 'Geografía administrativa'],
        ['GEX', 'Geografía extendida'],
        ['HOU', 'Horas'],
        ['LEN', 'Entidad legal'],
        ['LOC', 'Ubicación'],
        ['MAI', 'Correo'],
        ['MEA', 'Medida'],
        ['MISC', 'Otros'],
        ['MMD', 'Órgano de prensa'],
        ['MON', 'Dinero'],
        ['NPH', 'Person'],
        ['PCT', 'Porciento'],
        ['PER', 'Persona'],
        ['PHO', 'Teléfono'],
        ['PPH', 'Fenómeno físico'],
        ['PRD', 'Producto'],
        ['ORG', 'Organización'],
        ['VCL', 'Vehículo'],
        ['WEB', 'Web'],
    ];
    nodes: NodeItem[];
    edges: EdgeItem[];
    nodesTopics: { id: number; value: number; label: string; color: string }[];
    edgesTopics: { from: number; to: number; value: number; color: string }[];
    httpOptions = {
        headers: new HttpHeaders({
            "Content-Type": "application/json",
        })
    };

    dataSource: { position: any, text: any, sentiment: any, topic: any }[] = []

    selectedType: any;
    token: string;

    constructor(private http: HttpClient, protected $gaService: GoogleAnalyticsService) { }

    async ngOnInit(): Promise<void> {
        this.isProcessingArticle = false;
        this.showResults = false;
        this.tokenHasError = [false, ''];
        this.hasErrorProcessing = [false, '']
        this.progressInfo = {
            total: 0,
            current: 0,
            position: null,
            description: ''
        };
        this.providerInfoForm = new FormGroup({
            ptexto: new FormControl("", [Validators.required]),
            ptoken_compai: new FormControl("", [Validators.required]),
        });

        this.chartOptions = {
            maintainAspectRatio: false,
            responsive: true,
            tooltips: { mode: "index", intersect: false },
            hover: { mode: "nearest", intersect: true },
            legend: { display: false },
            scales: {
                xAxes: [
                    {
                        display: true,
                        ticks: { suggestedMin: 0, stepSize: 1 },
                        gridLines: {
                            borderDash: [2],
                            borderDashOffset: [2],
                            color: "rgba(33, 37, 41, 0.3)",
                            zeroLineColor: "rgba(33, 37, 41, 0.3)",
                            zeroLineBorderDash: [2],
                            zeroLineBorderDashOffset: [2],
                        },
                    },
                ],
                yAxes: [
                    {
                        display: true,
                        gridLines: {
                            borderDash: [2],
                            drawBorder: false,
                            borderDashOffset: [2],
                            color: "rgba(33, 37, 41, 0.2)",
                            zeroLineColor: "rgba(33, 37, 41, 0.15)",
                            zeroLineBorderDash: [2],
                            zeroLineBorderDashOffset: [2],
                        },
                    },
                ],
            },
        };

        this.$gaService.pageView("/", "Topics Analyzer");
    }

    async processArticleAsync() {
        this.$gaService.event("analyze_news");

        this.isProcessingArticle = true;
        this.tokenHasError = [false, ''];
        this.hasErrorProcessing = [false, ''];
        const startTime = Date.now()
        this.showResults = false;

        const text = this.providerInfoForm.value.ptexto;
        this.token = this.providerInfoForm.value.ptoken_compai;
        let errorMsg = 'Ha ocurrido un error procesando la información sobre el tema. Por favor inténtelo de nuevo.'

        if (this.isProcessing() || text === '' || this.token === '')
            return;

        const jobInfo = await this.callTopicsAnalyzerEndpointV2(text, this.token);
        if (jobInfo === undefined) {
            showErrorMessage();
            return
        }
        console.log(jobInfo);

        let response = await this.callJobResultsEndpointV2(jobInfo.job);
        if (response === undefined) {
            showErrorMessage();
            return
        }
        while (response.status !== 'FINISHED' && response.status !== 'ERROR') {
            response = await this.callJobResultsEndpointV2(jobInfo.job);
            if (response === undefined) {
                showErrorMessage();
                return
            }
            if (response.result !== undefined && _.keys(response.result).length > 0) {
                this.progressInfo.current = response.result.progress.current;
                this.progressInfo.total = response.result.progress.total;
                this.progressInfo.description = response.result.progress.description;
            }
            this.progressInfo.position = response.position;
            await timer(3000).pipe(take(1)).toPromise();
        }
        console.log(response);
        switch (response.status) {
            case 'FINISHED':
                this.showResults = false;
                if (response.result === undefined ||
                    response.result === null) {
                    this.hasErrorProcessing = [true, errorMsg]
                }
                else if (response.result[0] !== undefined && response.result[0] === 'error-token') {
                    const tokenErrorMap = {
                        'token-not-provided': 'El token no fue provisto.',
                        'token-inactive': 'El token existe pero no está activo.',
                        'token-without-points': 'El token existe pero no tiene puntos disponibles.',
                        'token-not-exist': 'El token no existe en la base de datos.'
                    };
                    errorMsg = tokenErrorMap[response.result[1][0]];
                    this.tokenHasError = [true, errorMsg];
                }
                else if (response.result.analysis_result.length === 0) {
                    this.hasErrorProcessing = [true, 'No se pudo obtener ninguna información textual sobre el tema. Si considera que pudo haber sido un problema de la aplicación, contáctenos para chequear los resultados.']
                }
                else {
                    this.showResults = true;
                    await this.updateCharts(response);
                }
                break;
            case 'ERROR':
                this.showResults = false;
                break;
        }
        console.log('Process ' + response.status.toLowerCase());
        this.progressInfo = {
            total: 0,
            current: 0,
            position: null,
            description: ''
        };
        this.isProcessingArticle = false;
        print_duration(startTime)

        if (!this.showResults)
            return

        this.nodes = [];
        let id = 1;
        const textIdxEnts = []
        const { entityValues, paragraphs } = this.extractEntityValues(response, ['MISC'])

        // tslint:disable-next-line:forin
        for (const label of entityValues) {
            let count = 0;
            let textIdx = 0;
            for (const item of paragraphs) {
                if (item.toLowerCase().indexOf(label.toLowerCase()) >= 0) {
                    count++;
                    textIdxEnts.push([textIdx, id])
                }
                textIdx++;
            }

            const node = { id, value: count, label };
            this.nodes.push(node);
            id++;
        }
        this.nodes = cleanSuspectNodes(this.nodes);

        this.edges = [];

        // tslint:disable-next-line:forin
        for (let k = 1; k <= this.nodes.length; k++) {
            const partners = getPartners(k, textIdxEnts)
            for (const p of partners)
                addEdge(k, p, this.edges)
        }

        this.nodes = removeNonConnectedNodes(this.nodes, this.edges)
        const tmp = mergeSimilarNodes(this.nodes, this.edges)
        this.nodes = tmp[0]
        console.log(['Nodes', this.nodes.length])
        this.edges = tmp[1]
        this.edges = mergeSimilarEdges(this.edges)
        this.edges = cleanEdgesBasedOnAmount(this.edges)
        this.nodes = removeNonConnectedNodes(this.nodes, this.edges)

        console.log(['Edges', this.edges.length])

        const tmpTopics = this.buildGraphTopics(
            this.getTopicsParagraphs(response),
            this.getSentimenParagraphs(response))

        this.nodesTopics = tmpTopics[0]
        this.edgesTopics = tmpTopics[1]

        this.dataSource = this.buildDataSource(response)

        function showErrorMessage() {
            this.hasErrorProcessing = [true, errorMsg];
            this.showResults = false;
        }
    }

    buildDataSource(jobResult: ResponseJobResultTopicsV2): { position: any; text: any; sentiment: any; topic: any; }[] {
        const res = []
        let idx = 1
        this.processGeneratorItem(
            this.paragraphsGenerator(jobResult),
            x => {
                let topic = 'desconocido'
                const topicHasValue = x.res_analysis.topics.toString() !== '' && _.keys(x.res_analysis.topics).length > 0;
                if (topicHasValue)
                    topic = _.keys(x.res_analysis.topics)[0]

                res.push({
                    position: idx,
                    text: x.text,
                    sentiment: this.convertSentimentArrayToStringV2(x.res_analysis.sentiment),
                    topic
                })
                idx += 1
            })
        return res
    }

    getSentimenParagraphs(jobResult: ResponseJobResultTopicsV2) {
        const res = []
        this.processGeneratorItem(
            this.paragraphsGenerator(jobResult),
            x => {
                const sentiment: number[] = x.res_analysis.sentiment
                if (sentiment.reduce((p, c) => p + c, 0) === 0)
                    res.push({ label: 'desconocido', score: 0 })
                else {
                    const label = this.convertSentimentArrayToStringV2(sentiment);
                    res.push({ label, score: 0 })
                }
            })
        return res
    }

    convertSentimentArrayToString(sentiment: number[]): string {
        let label = '';
        if (sentiment[0] === 1 || sentiment[1] === 1)
            label = 'negativo';
        else if (sentiment[2] === 1)
            label = 'neutral';
        else if (sentiment[3] === 1 || sentiment[4] === 1)
            label = 'positivo';
        return label;
    }

    convertSentimentArrayToStringV2(sentiment: number[]): string {
        const binarySentiment = parseInt(sentiment.join(''), 2);
        if (binarySentiment > 4) return 'negativo'
        if (binarySentiment === 4) return 'neutral'
        if (binarySentiment < 4 && binarySentiment > 0) return 'positivo'
        return 'desconocido'
    }

    getTopicsParagraphs(jobResult: ResponseJobResultTopicsV2) {
        const res = []
        this.processGeneratorItem(
            this.paragraphsGenerator(jobResult),
            x => {
                if (x.res_analysis.topics.toString() === '')
                    res.push(['desconocido', 0])
                else {
                    const firstTopic = _.keys(x.res_analysis.topics)[0]
                    res.push([firstTopic, 0])
                }
            })
        return res
    }

    processGeneratorItem(generator, fn: (arg0: any) => void) {
        let curr = generator.next()
        while (!curr.done) {
            const val = curr.value
            fn(val)
            curr = generator.next()
        }
    }

    /**
     * Extracts entity values from jobResults and returns an object containing the extracted
     * entity values and the paragraphs from jobResults.
     * @param jobResults - The jobResults object from which to extract entity values.
     * @param exceptList - A list of entities to exclude from extraction.
     * @returns An object containing the extracted entity values and the paragraphs from jobResults.
     *  - entityValues: an array of extracted entity values.
     *  - paragraphs: an array of paragraphs from jobResults.
     */
    extractEntityValues(jobResults: ResponseJobResultTopicsV2, exceptList: string[]): { entityValues: any[]; paragraphs: any[]; } {
        let entityValues = []
        const paragraphs = []

        const generator = this.paragraphsGenerator(jobResults)
        let curr = generator.next()
        while (!curr.done) {
            const val = curr.value
            paragraphs.push(val.text)
            const entities = val.res_analysis.entities

            // tslint:disable-next-line:forin
            for (const key in entities) {
                if (_.contains(exceptList, key))
                    continue
                entityValues = _.union(entityValues, _.keys(entities[key]))
            }

            curr = generator.next()
        }
        return { entityValues, paragraphs }
    }

    buildGraphTopics(listTopics: any[], listSentiments: { label: string, score: number }[]): any {
        const nodes: {
            id: number; value: number; label: string; color: string, posCount: number, negCount: number
        }[] = []
        const edges: {
            from: number; to: number; value: number; color: string, posCount: number, negCount: number
        }[] = []

        let prevNode: { id: number; value: number; label: string; }
        for (let i = 0; i < listTopics.length; i++) {
            const topicValue = listTopics[i][0]
            let posCount = 0
            let negCount = 0
            listSentiments[i].label.startsWith('positiv') ? posCount++ : negCount++

            let nodeFound = find(nodes, (n) => n.label === topicValue)
            if (nodeFound === undefined) {
                const tmpNode = {
                    id: i + 1, value: 1, label: topicValue, color: undefined,
                    posCount,
                    negCount
                }
                nodes.push(tmpNode)
                nodeFound = tmpNode
            }
            else {
                nodeFound.value++
                nodeFound.posCount += posCount
                nodeFound.negCount += negCount
            }
            if (prevNode !== undefined && prevNode.id !== nodeFound.id) {
                let ePos = 0
                let eNeg = 0
                listSentiments[i - 1].label.startsWith('positiv') ? ePos++ : eNeg++
                listSentiments[i].label.startsWith('positiv') ? ePos++ : eNeg++
                addEdge(prevNode.id, nodeFound.id, edges, ePos, eNeg)
            }
            prevNode = nodeFound
        }
        this.setColors(nodes);
        this.setColors(edges);

        return [nodes, edges]
    }


    private setColors(itemList: { color: string; posCount: number; negCount: number; }[]) {
        let color: any;
        let alpha: any;
        for (const item of itemList) {
            [color, alpha] = getColor(item.negCount, 0, item.posCount);
            const rgbStr = _.chain(rgba2rgb(color, alpha))
                .map(x => x.toString())
                .value();
            item.color = `rgb(${rgbStr})`;
        }
    }

    myIsNaN(n: number): boolean {
        return isNaN(n)
    }

    private async callJobResultsEndpointV2(jobId: string) {
        const endpointUrl = environment.appsUrl + 'v2/topics_analyzer/job_result/' + jobId;

        const urls = []
        urls.push(environment.heroku + 'apps/v2/topics_analyzer/job_result/' + jobId)
        urls.push(applyRegion(endpointUrl, environment.renderRegions.oregon))
        urls.push(applyRegion(endpointUrl, environment.renderRegions.frankfurt))

        for (const link of urls) {
            try {
                return await this.http.get<ResponseJobResultTopicsV2>(link, this.httpOptions).pipe().toPromise();
            } catch (error) {
                continue
            }
        }
    }

    private async callTopicsAnalyzerEndpointV2(text: string, token: string) {
        const body = {
            token,
            topic_search: text,
            domains: '',
            from_date: '',
            to_date: '',
        };
        const endpointUrl = environment.appsUrl + 'v2/topics_analyzer'

        const urls = []
        urls.push(environment.heroku + 'apps/v2/topics_analyzer')
        urls.push(applyRegion(endpointUrl, environment.renderRegions.oregon))
        urls.push(applyRegion(endpointUrl, environment.renderRegions.frankfurt))

        for (const link of urls) {
            try {
                return await this.http.post<ResponseJobInfo>(link, body, this.httpOptions).pipe().toPromise();
            } catch (error) {
                continue
            }
        }
    }

    private async updateCharts(jobResult: ResponseJobResultTopicsV2) {
        const results = jobResult.result.analysis_result;

        if (_.isEmpty(results)) return;

        this.itemsTitle = 'Párrafos'

        for (const ar of results)
            for (const link of ar.links)
                this.itemsLength += link.paragraphs.length

        this.nerTypes = this.createNerTypes(jobResult);

        this.commentsNer = this.createItemsEntities(jobResult)
        this.commentsNerLabels = _.chain(this.commentsNer)
            .allKeys()
            .sortBy((x) => x)
            .value();

        this.onNERSelectedChanged(this.commentsNerLabels[0]);

        this.updateBarChartTopics(jobResult);
        this.updateBarChartSentiment(jobResult);
    }

    createNerTypes(jobResults: ResponseJobResultTopicsV2): any[] {
        const res = [];
        const generator = this.paragraphsGenerator(jobResults)
        let curr = generator.next()
        while (!curr.done) {
            const entities = curr.value.res_analysis.entities
            Object.keys(entities).forEach(key => {
                const longKey = this.getLongKey(key)

                const idx = res.findIndex(x => x[0] === key)
                if (idx === -1)
                    res.push([key, Object.keys(entities[key]), longKey])
                else
                    res[idx][1].concat(entities[key])
            })
            curr = generator.next()
        }
        return res
    }

    *paragraphsGenerator(jobResults: ResponseJobResultTopicsV2)
        : IterableIterator<{
            res_analysis: { entities: {}, sentiment: number[], topics: {} },
            text: string
        }> {
        for (const ar of jobResults.result.analysis_result) {
            for (const link of ar.links) {
                for (const p of link.paragraphs) {
                    yield p
                }
            }
        }
    }

    createItemsEntities(jobResults: ResponseJobResultTopicsV2): {} {
        const res: {} = {};
        const generator = this.paragraphsGenerator(jobResults)
        let curr = generator.next()
        while (!curr.done) {
            const ra = curr.value.res_analysis
            Object.keys(ra.entities).forEach(entityType => {
                if (!res.hasOwnProperty(entityType))
                    res[entityType] = {}
                Object.keys(ra.entities[entityType]).forEach(entity => {
                    if (!res[entityType].hasOwnProperty(entity))
                        res[entityType][entity] = 0
                    res[entityType][entity] += 1
                })
            })
            curr = generator.next()
        }
        return res
    }


    updateBarChartTopics(jobResults: ResponseJobResultTopicsV2) {
        console.log('Update bar chart of topics ...')
        const labels = {};
        const unkKey = 'desconocido'

        for (const ar of jobResults.result.analysis_result) {
            for (const link of ar.links) {
                for (const p of link.paragraphs) {
                    if (p.res_analysis.topics.toString() === '') {
                        if (!_.has(labels, unkKey))
                            labels[unkKey] = 0
                        labels[unkKey] += 1
                    }
                    // tslint:disable-next-line:forin
                    for (const key in p.res_analysis.topics) {
                        if (!_.has(labels, key))
                            labels[key] = 0
                        labels[key] += 1
                    }
                }
            }
        }

        const configTopics = {
            type: "horizontalBar",
            data: {
                labels: _.keys(labels),
                datasets: [
                    {
                        backgroundColor: "#4c51bf",
                        borderColor: "#4c51bf",
                        data: _.values(labels),
                        fill: false,
                        barThickness: 8,
                    },
                ]
            },
            options: this.chartOptions,
        };

        if (this.barChartTopics !== undefined)
            this.barChartTopics.destroy();
        let ctx: any = document.getElementById("bar-chart-topics");
        ctx = ctx.getContext("2d");
        this.barChartTopics = new Chart(ctx, configTopics);
    }

    updateBarChartSentiment(jobResults: ResponseJobResultTopicsV2) {
        const sentiments = [0, 0, 0, 0, 0];

        jobResults.result.analysis_result.forEach(ar => {
            ar.links.forEach(link => {
                link.paragraphs.forEach(p => {
                    p.res_analysis.sentiment.forEach((s, i) => {
                        sentiments[i] += s;
                    });
                });
            });
        });

        const configSentiment = {
            type: "horizontalBar",
            data: {
                labels: ["1", "2", "3", "4", "5",],
                datasets: [
                    {
                        backgroundColor: "#4c51bf",
                        borderColor: "#4c51bf",
                        data: sentiments,
                        fill: false,
                        barThickness: 8,
                    },
                ],
            },
            options: this.chartOptions,
        };

        if (this.barChartSentiment !== undefined)
            this.barChartSentiment.destroy();
        let ctx: any = document.getElementById("bar-chart-sentiment");
        ctx = ctx.getContext("2d");
        this.barChartSentiment = new Chart(ctx, configSentiment);
    }

    join(separator: string, list: string[]) {
        return list.join(separator)
    }

    isProcessing() {
        if (this.showResults === true)
            return false;
        return this.progressInfo.total > 0 && this.progressInfo.total !== this.progressInfo.current;
    }

    onNERSelectedChanged(newLongKey: string) {
        this.selectedNERType = this.getKey(newLongKey);
        const lbls = _.chain(this.commentsNer[this.selectedNERType])
            .allKeys()
            .sortBy((x) => x)
            .value()
        const values = [];
        for (const lbl of lbls) {
            values.push(this.commentsNer[this.selectedNERType][lbl]);
        }
        const dataSourceNer = {
            labels: lbls,
            datasets: [
                {
                    backgroundColor: "#ed64a6",
                    borderColor: "#ed64a6",
                    data: values,
                    fill: false,
                    barThickness: 8,
                },
            ],
        }
        const configNer = {
            type: "horizontalBar",
            data: dataSourceNer,
            options: this.chartOptions,
        };

        if (this.barChartNer !== undefined)
            this.barChartNer.destroy();
        let ctx: any = document.getElementById("bar-chart-ner");
        ctx = ctx.getContext("2d");
        this.barChartNer = new Chart(ctx, configNer);
    }

    getLongKey(key: string): string {
        for (const item of this.pairsKeyLongKey)
            if (item[0] === key)
                return item[1]
        return key
    }

    getKey(longKey: string): string {
        for (const item of this.pairsKeyLongKey)
            if (item[1] === longKey)
                return item[0]
        return longKey
    }
}
